// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'chart-pie';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M10.152.576v6.768h6.768C16.848 3.6 13.824.576 10.152.576zm-2.304 10.08V3.96a6.76 6.76 0 0 0-6.768 6.768 6.76 6.76 0 0 0 6.768 6.768c1.512 0 2.952-.504 4.176-1.44zm9-1.08H10.08l4.176 5.328a6.72 6.72 0 0 0 2.592-5.328z'
  />
);

export const viewBox = '0 0 18 18';
